import styled from 'styled-components'

const MainText = styled.h1`
    font-size: 3.95rem;
    font-weight: 600;
    margin-top: 0;
`

export default MainText